import StateInterface from "../state-interface";

export const requirement: StateInterface["requirement"] = {
	_id: "",
	title: "",
	posted_by: {
		user_id: "",
		business_profile_id: "",
		role: "",
		is_business_profile: false,
		is_staff_post: false,
		external_user: {
			name: "",
			phone: { country_code: "", phone_number: "" },
			source: "",
		},
	},
	transaction_type: "",
	property_category: "",
	property_type: [],
	project_name: "",
	locations: [],
	budget: { min: 0, max: 0, currency: "INR", is_flexible: false },
	configuration: {
		bhk: [],
		area_min: 0,
		area_max: 0,
		area_unit: "sqft",
		furnishing: "",
		possession_by: "",
		seats: 0,
		plot_dimensions: [],
	},
	notes: "",
	brokerage: { is_offering_brokerage: false, value: 0 },
	contact_preference: [],
	status: "",
	status_history: [],
	activated_at: "",
	expires_at: "",
	closed_at: "",
	expiry_warning_sent: false,
	extension_count: 0,
	extended_at: "",
	claim_count: 0,
	total_claim_count: 0,
	claim_holds: [],
	repost_count: 0,
	is_deleted: false,
	deleted_at: "",
	created_at: "",
	updated_at: "",
};
